import http from "../../../../services/httpService";
import { injectHtml } from "../../../../utils/htmlUtil";
import { error, isEmpty, initToggleIconRotate, rotateElement } from "../../../common/global";
import { catchError } from "../../../../utils/errorUtil";
import forms from "../../../common/forms";

const props = {

    modalPlaceholder: '#popup-placeholder',

    //MARKERS
    adminOrderCoreDetailsMarker: '#marker-order-core-details',
    adminWorkflowAwaitingProcessingMarker: '#marker-order-workflow-awaiting-processing',

    //ASSIGN ORDER
    initialAssignmentDropDown: '#initial-assignment',
    editAssignedUser: '.edit-assigned-user',
    assignedToCurrent: '#assigned-to-current',
    assignedToChange: '#assigned-to-change',
    assignedTeamMemberDropDown: '#assigned-team-member',

    //STATUS - AWAITING PROCESSING
    enteredIntoSap: '#entered-into-sap-yes',
    confirmEnteredIntoSap: '#entered-into-sap-confirm',

    //ORDER CANCELLATION
    cancelOrder: '#cancel-order',
    orderCancellationModal: '#order-cancellation-modal',
    orderCancellationModalId: 'order-cancellation-modal',
    orderCancellationForm: '#order-cancellation-form',
    orderCancellationConfirmation: '#order-cancellation-confirmation',

    // COURIER
    trackingNumber: '#tracking-number',
    selectedCourier: '#selected-courier',
    customerEmail: '#customer-email',
    updateTrackingNumberButton: '#update-tracking-number-button',
    sendTrackingEmailButton: '#send-tracking-email-button',

    editAssignedCourier: '.edit-assigned-courier',
    courierCurrent: '#courier-current',
    courierChange: '#courier-change',
    assignedCourierDropDown: '#assigned-courier',
};

export function initAdminOrderWorkflow() {

    if ($(props.adminWorkflowAwaitingProcessingMarker).length) {

        //marker for specific workflow stage event (awaiting processing)
        initAwaitingProcessingEvents();         
    }

    if ($(props.initialAssignmentDropDown).length) {

        //if the 'initial assignment' drop down is displayed on the page bind the relevant events
        initOrderInitialAssignmentEvent();
    }

    if ($(props.adminOrderCoreDetailsMarker).length) {

        //makrer for the core details view
        initChangeAssignedUserEvents();
        initChangeAssignedUserEvents();

        //NOTE: disabled as accidentally merged into master
        initOrderCancellationEvents();
    }
}

async function initAwaitingProcessingEvents() {

    catchError(async function () {

        $(props.enteredIntoSap).off('click').on('click', async function () {

            $(props.confirmEnteredIntoSap).prop('disabled', false);

        });
    });
}

async function initOrderInitialAssignmentEvent() {

    catchError(async function () {

        $(props.initialAssignmentDropDown).off('change').on('change', async function () {

            const data = {
                orderId: $(props.initialAssignmentDropDown).data('order-id'),
                assignToId: $(props.initialAssignmentDropDown).val()
            };

            const result = await assignOrderService(data);

            location.reload();
        });
    });
}

async function initChangeAssignedUserEvents() {

    catchError(async function () {

        $(props.editAssignedUser).off('click').on('click', async function () {

            $(props.assignedToCurrent).hide(500, function () {
                $(props.assignedToChange).show(500);
            });

        });


        $(props.assignedTeamMemberDropDown).off('change').on('change', async function () {

            const data = {
                orderId: $(props.assignedTeamMemberDropDown).data('order-id'),
                assignToId: $(props.assignedTeamMemberDropDown).val()
            };

            const result = await assignOrderService(data);

            location.reload();
        });
        $(props.editAssignedCourier).off('click').on('click', async function () {

            $(props.courierCurrent).hide(500, function () {
                $(props.courierChange).show(500);
            });

        });
        $(props.assignedCourierDropDown).off('change').on('change', async function () {

            const data = {
                orderId: $(props.assignedCourierDropDown).data('order-id'),
                courierId: $(props.assignedCourierDropDown).val()
            };
            await updateCourier(data);
            console.log(data);
            location.reload();
        });

        $(props.sendTrackingEmailButton).off('click').on('click', async function () {
            const data = {
                orderId: $(props.assignedCourierDropDown).data('order-id'),
                courier: $(props.selectedCourier).val(),
                trackingNumber: $(props.trackingNumber).val(),
                customerEmail: $(props.customerEmail).val()
            };
            console.log(data);
            await sendTrackingEmail(data);
            location.reload();
        });

        $(props.updateTrackingNumberButton).off('click').on('click', async function () {
            const data = {
                orderId: $(props.assignedCourierDropDown).data('order-id'),
                trackingNumber: $(props.trackingNumber).val()
            };

            await updateTrackingNumber(data);
            console.log(data);
            location.reload();
        });

    });
}

async function initOrderCancellationEvents() {

    catchError(async function () {

        $(props.cancelOrder).off('click').on('click', async function () {

            await initOrderCancellationDisplayModal();

        });

    });
}



async function initOrderCancellationDisplayModal() {

    const orderId = $(props.cancelOrder).data('order-id');

    const data = {
        id: orderId
    };

    const result = await getOrderCancellationModalHtml(data);

    await injectHtml(props.modalPlaceholder, result);

    //bind 'modal on shown' events
    await initOrderCancellationDisplayModalOnShow();

    //launch modal
    $(props.orderCancellationModal).modal('show');
}


function initOrderCancellationDisplayModalOnShow() {

    catchError(async function () {

        //when the modal is shown bind all relevant events
        $(props.orderCancellationModal).off('shown.bs.modal').on('shown.bs.modal', async function (e) {

            //init standard mdc elements
            window.mdc.autoInit(document.getElementById(props.orderCancellationModalId));

            //bind submit event
            initSubmitOrderCancellationEvents();

            $('#Reason').focus();
        })
    });
}


async function initSubmitOrderCancellationEvents() {

    catchError(async function () {

        const formObject = $(props.orderCancellationForm);

        //only attempt validation / binding if the form is present
        if (formObject.length > 0) {

            //initialise jquery validation for the injected form
            const validator = forms.onloadValidationSetupByObject(formObject);

            $(props.orderCancellationConfirmation).off('click').on('click', async function () {

                forms.addRequiredRule($('#Reason'));

                //validate form
                if (formObject.valid()) {

                    const parent = $(props.orderCancellationForm);

                    const activityIndicator = parent.find('.modal-activity-indicator');

                    activityIndicator.show().css("display", "inline-block");

                    forms.formUnderSubmission(true);

                    setTimeout(async function () {

                        const formValues = formObject.serialize();

                        //attempt POST save, the check response
                        const response = await orderCancellationConfirmedService(formValues);

                        //reload page regardless of result. snackbar will be displayed for success / failure upon reload.
                        location.reload();

                        forms.formUnderSubmission(false);

                    }, 1000);
                } else {

                    //no scroll to in modal
                    //app.forms.scrollToFirstError(validator, $(document).height() * 0.5);
                }
            });
        }
    });
}


//API CALLS
async function sendTrackingEmail(data) {
    const response = await http.post('/administration/orderworkflow/sendtrackingemail', data);

    return response.data;
}
async function updateCourier(data) {
    const response = await http.post('/administration/orderworkflow/updatecourier', data);

    return response.data;
}
async function updateTrackingNumber(data) {
    const response = await http.post('/administration/orderworkflow/updatetrackingnumber', data);

    return response.data;
}


async function assignOrderService(data) {

    //no TRY CATCH as handled by parent
    //returns json result of remove from basket attempt
    const response = await http.post('/administration/orderworkflow/assignorderpost', data);

    return response.data;
}

async function getOrderCancellationModalHtml(data) {

    //no TRY CATCH as handled by parent
    const response = await http.post('/administration/orderworkflow/buildordercancellationmodal', data);

    // The response is an object with a property called 'data'. This contains the modal HTML.
    return response.data;
}


async function orderCancellationConfirmedService(data) {

    //no TRY CATCH as handled by parent
    const response = await http.post('/administration/orderworkflow/ordercancellationconfirmed', data);

    return response.data;
}